import { MenuItem, MenuList, Typography } from '@mui/material';
import React from 'react';

import { PopperSubmenuContainer } from '../../Components/PopperSubmenuContainer';
import { NAV_COLOR_PALETTE } from '../../Components/styleConstants';

import { delayedMobileCloseClickHandler } from '../../Components/utils';
import { DATA_OG, DATA_TEST, getDynamicDataOGId } from '../../enums';
import { ICreateNewActionItem } from '../../types';
import { focusElementOnShiftTabKeydown, handleTabOrEscapeToLeaveSubmenu } from '../../utils/keyboardNavUtils';

interface ICreateNewActionSubmenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  actions: ICreateNewActionItem[];
  accessibility: {
    associatedButtonId: string;
    id: string;
  };
  firstSubmenuItemRef?: React.MutableRefObject<HTMLLIElement>;
  handleClose(): void;
  handleClick(action: ICreateNewActionItem): void;
}

export const CreateNewActionSubmenu: React.FC<ICreateNewActionSubmenuProps> = ({
  anchorEl,
  open,
  actions,
  accessibility,
  firstSubmenuItemRef,
  handleClick,
  handleClose
}) => {
  const { associatedButtonId, id } = accessibility;
  return (
    <PopperSubmenuContainer
      anchorEl={anchorEl}
      open={open}
      disablePortal={true}
      positionOffset={{ x: 0, y: 2 }}
      dataTest={DATA_TEST.create_new_action_submenu}
      placement="bottom-end"
      keydownCallbacks={(e, keydownHappenedInContainer) => {
        focusElementOnShiftTabKeydown(e, keydownHappenedInContainer, anchorEl);
      }}
      handleClose={() => {
        delayedMobileCloseClickHandler(handleClose);
      }}
    >
      <MenuList autoFocusItem={open} id={id} aria-labelledby={associatedButtonId}>
        {actions.map((action, index) => {
          const dataOg = action.dataOg ? action.dataOg : action.label;

          return (
            <MenuItem
              ref={index === 0 ? firstSubmenuItemRef : undefined}
              key={action.label}
              sx={{
                py: 0.5,
                px: 2,
                color: NAV_COLOR_PALETTE.primaryGray,
                minHeight: '40px !important'
              }}
              tabIndex={-1}
              onClick={() => handleClick(action)}
              onKeyDown={(keyboardEvent) => {
                handleTabOrEscapeToLeaveSubmenu(keyboardEvent.key, anchorEl);
              }}
              data-og={getDynamicDataOGId(DATA_OG.create_new_action_button, dataOg)}
            >
              <Typography variant="bodySmall">{action.label}</Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </PopperSubmenuContainer>
  );
};
